import api from './api';
import Swal from "vue-sweetalert2";

export default {

    async getLanderDetails({ commit, dispatch, getters }, payload) {
        let prospectId = sessionStorage.getItem('prospectId')
        if (prospectId !== null) {
            payload.prospectId = prospectId
        }
        let response = await api.getLanderDetails(payload)
        if (response?.data?.success && !payload.ups) {
            commit('setProspectSession', response.data?.data?.prospect?.prospectId);
        }
        return response;
    },

    //Prospect Actions
    async saveProspect({commit, dispatch, getters}, prospect) {
        let response = await api.saveProspect(prospect)
        if (response?.data?.success) {
            commit('setProspectSession', response.data.data.prospectId);
        }
        return response;
    },

    async payForSubscription({ commit }, data) {
        const response = await api.payAndSubscribe(data);
        if (response?.data?.success) {
            commit('clearProspectSession');
            commit('setAuthToken', response.data?.data?.authToken);
        }
        return response;
    },

    async getConvergePaymentSession({ commit, state }) {
        return await api.getConvergeSessionToken();
    },

    async getThanqPageData({commit}, {productCode, tp}) {
        return await api.getUserProductSummary(productCode, tp)
    },

    async upsellSubscription({commit}, data) {
        return await api.subscribeUpsell(data);
    },

    async loadCaptcha() {
        return await api.loadCaptcha();
    },

    async serverLog({commit}, data) {
        return await api.logElk(data);
    },

    async sendMobileVerificationCode({commit, getters}, data) {
        return api.sendMobileVerificationCode(data);
    },

    async validateMobileVerificationCode({commit, getters}, data) {
        return api.validateMobileVerificationCode(data)
    }


}
